<template>
  <div>
    <Filtro @filtro="makeFiltro"></Filtro>
    <div class="vx-row">
      <div class="divCreditos vs-con-loading__container vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4 mb-base pb-6">
        <statistics-card-line icon="false" class="cards" :statistic="formatCurrency(analyticsData.valorCreditado.qtd)"
          statisticTitle="Valor créditado" :chartData="analyticsData.valorCreditado" color="dark"
          type="area"></statistics-card-line>
        <statistics-card-line icon="false" class="cards" :statistic="formatCurrency(analyticsData.valorEmAberto.qtd)"
          statisticTitle="Valor em aberto" :chartData="analyticsData.valorEmAberto" color="dark"
          type="area"></statistics-card-line>
      </div>
      <div class="divCaixas vs-con-loading__container vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4 mb-base">
        <statistics-card-line icon="false" class="cards" :statistic="analyticsData.qtdCaixasAbertas.qtd"
          statisticTitle="Quantidade de caixas abertas" :chartData="analyticsData.qtdCaixasAbertas" color="dark"
          type="area"></statistics-card-line>
        <statistics-card-line icon="false" class="cards" :statistic="formatCurrency(analyticsData.cmeFinanceiro)"
          statisticTitle="CME" :chartData="{
            labels: ['cmeFinanceiro'],
            datasets: [{ data: [analyticsData.cmeFinanceiro] }],
          }" color="dark" type="area"></statistics-card-line>
      </div>


      <div class="divCaixas vs-con-loading__container vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4 mb-base">
        <statistics-card-line icon="false" class="cards" :statistic="formatCurrency(analyticsData.cmvFinanceiro)"
          statisticTitle="CMV" :chartData="{
            labels: ['cmvFinanceiro'],
            datasets: [{ data: [analyticsData.cmvFinanceiro] }],
          }" color="dark" type="area"></statistics-card-line>
        <statistics-card-line icon="false" class="cards" :statistic="formatCurrency(
          analyticsData.valorCreditado.qtd - analyticsData.cmeFinanceiro
        )
          " statisticTitle="Lucro Bruto" :chartData="{
            labels: ['lucroBruto'],
            datasets: [
              {
                data: [
                  analyticsData.valorCreditado.qtd -
                  analyticsData.cmeFinanceiro +
                  analyticsData.lucroSobreTroca,
                ],
              },
            ],
          }" color="dark" type="area"></statistics-card-line>
      </div>
      <div class="divCaixas vs-con-loading__container vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4 mb-base">
        <statistics-card-line icon="false" class="cards" :statistic="formatCurrency(analyticsData.lucroSobreTroca)"
          statisticTitle="Lucro Sobre a Troca" :chartData="{
            labels: ['Lucro'],
            datasets: [{ data: [analyticsData.lucroSobreTroca] }],
          }" color="dark" type="area"></statistics-card-line>
        <statistics-card-line icon="false" class="cards" :statistic="analyticsData.quantidadeTotalVendida"
          statisticTitle="Total Itens Vendidos" :chartData="{
            labels: ['Vendidos'],
            datasets: [{ data: [analyticsData.quantidadeTotalVendida] }],
          }" color="dark" type="area"></statistics-card-line>
      </div>
      <div class="divCaixas vs-con-loading__container vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4 mb-base">
        <statistics-card-line icon="false" class="cards" :statistic="formatCurrency(analyticsData.totalDeFretePago)"
          statisticTitle="Valor créditado em frete" :chartData="{
            labels: ['totalDeFretePago'],
            datasets: [{ data: [analyticsData.totalDeFretePago] }],
          }" color="dark" type="area"></statistics-card-line>
      </div>

      <div class="divCaixas vs-con-loading__container vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4 mb-base pb-6">
        <statistics-card-line icon="false" class="cards" :statistic="formatCurrency(analyticsData.saldoTotal)"
          statisticTitle="Saldo Total Dos Usuários" :chartData="{
            labels: ['saldoTotal'],
            datasets: [{ data: [analyticsData.saldoTotal] }],
          }" color="dark" type="area"></statistics-card-line>
      </div>

      <div class="divCaixas vs-con-loading__container vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4 mb-base pb-6">
        <statistics-card-line icon="false" class="cards" :statistic="formatCurrency(analyticsData.cmlTotal)"
          statisticTitle="CML - Custo Mercadoria no Limbo" :chartData="{
            labels: ['cmlTotal'],
            datasets: [{ data: [analyticsData.cmlTotal] }],
          }" color="dark" type="area"></statistics-card-line>
      </div>

      <div
        class="divTicketMedioIncluido vs-con-loading__container vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4 mb-base pb-6">
        <statistics-card-line icon="false" class="cards"
          :statistic="formatCurrency(analyticsData.ticketMedioIncluido.qtd)" statisticTitle="Ticket Médio Incluído"
          :chartData="analyticsData.ticketMedioIncluido" color="dark" type="area"></statistics-card-line>
      </div>

      <div
        class="divTicketMedioCML vs-con-loading__container vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4 mb-base pb-6">
        <statistics-card-line icon="false" class="cards" :statistic="formatCurrency(analyticsData.ticketMedioCML.qtd)"
          statisticTitle="Ticket Médio CML (Custo Mercadoria no Limbo)" :chartData="analyticsData.ticketMedioCML"
          color="dark" type="area"></statistics-card-line>
      </div>

      <div
        class="divTicketMedioVME vs-con-loading__container vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4 mb-base pb-6">
        <statistics-card-line icon="false" class="cards" :statistic="formatCurrency(analyticsData.ticketMedioVME.qtd)"
          statisticTitle="VME - Valor Médio de Encomendas" :chartData="analyticsData.ticketMedioVME" color="dark"
          type="area"></statistics-card-line>
      </div>

      <div class="divChurn vs-con-loading__container vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4 mb-base pb-6">
        <statistics-card-line icon="false" class="cards" :statistic="analyticsData.churn.qtd.toFixed(2) + '%'"
          statisticTitle="Churn (2+ caixas antes do período e nenhuma interação durante)"
          :chartData="analyticsData.churn" color="dark" type="area"></statistics-card-line>
      </div>

      <div class="divChurn vs-con-loading__container vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4 mb-base pb-6">
        <statistics-card-line icon="false" class="cards" :statistic="analyticsData.retention.qtd.toFixed(2) + '%'"
          statisticTitle="Taxa de Retenção" :chartData="analyticsData.retention" color="dark"
          type="area"></statistics-card-line>
      </div>

      <div class="divLTV vs-con-loading__container vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4 mb-base pb-6">
        <statistics-card-line icon="false" class="cards" :statistic="formatCurrency(analyticsData.ltv.qtd)"
          statisticTitle="LTV (Life Time Value)" :chartData="analyticsData.ltv" color="dark" type="area">
        </statistics-card-line>
      </div>

      <div class="divRecompra vs-con-loading__container vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4 mb-base pb-6">
        <statistics-card-line icon="false" class="cards" :statistic="analyticsData.taxaRecompra.qtd.toFixed(2) + '%'"
          statisticTitle="Taxa de Recompra (% de clientes com 2+ compras no período)"
          :chartData="analyticsData.taxaRecompra" color="dark" type="area">
        </statistics-card-line>
      </div>

      <div
        class="divTempoEntreCompras vs-con-loading__container vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4 mb-base pb-6">
        <statistics-card-line icon="false" class="cards"
          :statistic="formatarHorasDecimais(analyticsData.tempoEntreCompras.qtd)"
          statisticTitle=" Tempo Médio entre Compras" :chartData="analyticsData.tempoEntreCompras" color="dark"
          type="area">
        </statistics-card-line>
      </div>
      <div class="divCaixas vs-con-loading__container vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4 mb-base pb-6">
        <statistics-card-line icon="false" class="cards" :statistic="formatCurrency(analyticsData.totalVendas)"
          statisticTitle="Total de Vendas (preço de venda dos itens vendidos)" :chartData="{
            labels: ['totalVendas'],
            datasets: [{ data: [analyticsData.totalVendas] }],
          }" color="dark" type="area" />
      </div>

    </div>

    <div class="vx-row">
      <div id="qtdUsuarios"
        class="divQtdUsuarios vs-con-loading__container vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/2 xl:w-1/2 mb-base">
        <statistics-card-line icon="UserIcon" statistic="Quantidade Usuários" :chartData="analyticsData.qtdUsuarios"
          color="success" type="bar" :height="250" :iconRight="true" v-if="qtdUsuariosShow"></statistics-card-line>
      </div>
      <div id="valorAcumulado"
        class="divValorAcumulado vs-con-loading__container vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/2 xl:w-1/2 mb-base">
        <statistics-card-line icon="DollarSignIcon" statistic="Valor Creditado"
          :chartData="analyticsData.valorAcumulado" color="danger" type="bar" :height="250" :iconRight="true"
          v-if="valorAcumuladoShow"></statistics-card-line>
      </div>
    </div>
    <div class="vx-row" style="margin-top: 2%">
      <div id="aberturas"
        class="divAberturas vs-con-loading__container vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/2 xl:w-1/2 mb-base">
        <vx-card class="overflow-hidden">
          <div slot="no-body">
            <div :class="'p-6 pb-3 mb-3 flex justify-between flex-row-reverse items-center'">
              <feather-icon :icon="'GiftIcon'" class="p-3 inline-flex rounded-full" :class="[`text-dark`]"
                :style="{ background: `rgba(var(--vs-dark),.15)` }"></feather-icon>
              <div>
                <h2 class="mb-1 font-bold">Últimas Aberturas (TOP 100)</h2>
              </div>
            </div>

            <div class="p-6 pb-0">
              <vs-table noDataText="Nenhum dados Encontrado" class="tablePrincipal" ref="table"
                v-model="selectedAberturas" :data="aberturas" style="overflow-y: auto; height: 283px !important">
                <template slot="thead">
                  <vs-th :style="{ width: '50px' }" sort-key="nomeUsuario">Usuário</vs-th>
                  <vs-th :style="{ width: '50px' }" sort-key="caixa">Caixa</vs-th>
                  <vs-th :style="{ width: '50px' }" sort-key="item">Item</vs-th>
                  <vs-th :style="{ width: '50px' }" sort-key="vendido">Vendido</vs-th>
                </template>

                <template slot-scope="{ data }">
                  <tbody>
                    <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                      <vs-td>
                        <p class="product-category">
                          {{ tr.nomeUsuario }}
                          <router-link target="_blank" :to="`DetalheUsuario/${tr.idUsuario}`"></router-link>
                        </p>
                      </vs-td>
                      <vs-td>
                        <p class="product-category">{{ tr.nomeCaixa }}</p>
                      </vs-td>
                      <vs-td>
                        <p class="product-category">{{ tr.nomeItem }}</p>
                      </vs-td>
                      <vs-td>
                        <p class="product-category">{{ tr.vendido }}</p>
                      </vs-td>
                    </vs-tr>
                  </tbody>
                </template>
              </vs-table>
            </div>
          </div>
        </vx-card>
      </div>

      <div id="rankingAberturas"
        class="divRankingAberturas vs-con-loading__container vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/2 xl:w-1/2 mb-base">
        <vx-card class="overflow-hidden">
          <div slot="no-body">
            <div :class="'p-6 pb-3 mb-3 flex justify-between flex-row-reverse items-center'">
              <feather-icon :icon="'GiftIcon'" class="p-3 inline-flex rounded-full" :class="[`text-success`]"
                :style="{ background: `rgba(var(--vs-success),.15)` }"></feather-icon>
              <div>
                <h2 class="mb-1 font-bold">Ranking de Aberturas (TOP 20)</h2>
              </div>
            </div>
            <div class="p-6 pb-0">
              <vs-table noDataText="Nenhum dados Encontrado" class="tablePrincipal" ref="table"
                v-model="selectedRankingAberturas" :data="rankingAberturas"
                style="overflow-y: auto; height: 283px !important">
                <template slot="thead">
                  <vs-th :style="{ width: '50px' }" sort-key="caixa">Usuário</vs-th>
                  <vs-th :style="{ width: '50px' }" sort-key="item">Caixas Abertas</vs-th>
                </template>

                <template slot-scope="{ data }">
                  <tbody>
                    <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                      <vs-td>
                        <p class="product-category">
                          {{ tr.nome }}
                          <router-link target="_blank" :to="`DetalheUsuario/${tr.idUsuario}`"></router-link>
                        </p>
                      </vs-td>
                      <vs-td>
                        <p class="product-category">{{ tr.qtd }}</p>
                      </vs-td>
                    </vs-tr>
                  </tbody>
                </template>
              </vs-table>
            </div>
          </div>
        </vx-card>
      </div>

      <div id="rankingMaisAbertas"
        class="divRankingMaisAbertas vs-con-loading__container vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/2 xl:w-1/2 mb-base">
        <vx-card class="overflow-hidden">
          <div slot="no-body">
            <div :class="'p-6 pb-3 mb-3 flex justify-between flex-row-reverse items-center'">
              <feather-icon :icon="'BoxIcon'" class="p-3 inline-flex rounded-full" :class="[`text-warning`]"
                :style="{ background: `rgba(var(--vs-warning),.15)` }"></feather-icon>
              <div>
                <h2 class="mb-1 font-bold">Ranking de Caixas Mais Abertas</h2>
              </div>
            </div>

            <div class="p-6 pb-0">
              <vs-table noDataText="Nenhum dado encontrado" class="tablePrincipal" ref="table"
                v-model="selectedRankingMaisAbertas" :data="rankingMaisAbertas"
                style="overflow-y: auto; height: 283px !important">
                <template slot="thead">
                  <vs-th :style="{ width: '50%' }">Caixa</vs-th>
                  <vs-th :style="{ width: '50%' }">Aberturas</vs-th>
                </template>

                <template slot-scope="{ data }">
                  <tbody>
                    <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                      <vs-td>
                        <p class="product-category">{{ tr.nomeCaixa }}</p>
                      </vs-td>
                      <vs-td>
                        <p class="product-category">{{ tr.qtd }}</p>
                      </vs-td>
                    </vs-tr>
                  </tbody>
                </template>
              </vs-table>
            </div>
          </div>
        </vx-card>
      </div>

      <div id="rankingMaisResgatados"
        class="divRankingMaisResgatados vs-con-loading__container vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/2 xl:w-1/2 mb-base">
        <vx-card class="overflow-hidden">
          <div slot="no-body">
            <div class="p-6 pb-3 mb-3 flex justify-between flex-row-reverse items-center">
              <feather-icon icon="GiftIcon" class="p-3 inline-flex rounded-full text-success"
                :style="{ background: `rgba(var(--vs-success),.15)` }"></feather-icon>
              <div>
                <h2 class="mb-1 font-bold">Top Produtos Mais Resgatados</h2>
              </div>
            </div>

            <div class="p-6 pb-0">
              <vs-table noDataText="Nenhum dado encontrado" class="tablePrincipal" ref="table"
                v-model="selectedRankingMaisResgatados" :data="rankingMaisResgatados"
                style="overflow-y: auto; height: 283px !important">
                <template slot="thead">
                  <vs-th :style="{ width: '60%' }">Produto</vs-th>
                  <vs-th :style="{ width: '40%' }">Resgates</vs-th>
                </template>

                <template slot-scope="{ data }">
                  <tbody>
                    <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                      <vs-td>
                        <p class="product-category">{{ tr.nomeProduto }}</p>
                      </vs-td>
                      <vs-td>
                        <p class="product-category">
                          {{ tr.quantidadeResgatada }}
                        </p>
                      </vs-td>
                    </vs-tr>
                  </tbody>
                </template>
              </vs-table>
            </div>
          </div>
        </vx-card>
      </div>

      <div id="rankingMaisTrocados"
        class="divRankingMaisTrocados vs-con-loading__container vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/2 xl:w-1/2 mb-base">
        <vx-card class="overflow-hidden">
          <div slot="no-body">
            <div class="p-6 pb-3 mb-3 flex justify-between flex-row-reverse items-center">
              <feather-icon icon="RepeatIcon" class="p-3 inline-flex rounded-full text-danger"
                :style="{ background: `rgba(var(--vs-danger),.15)` }"></feather-icon>
              <div>
                <h2 class="mb-1 font-bold">Top Produtos Mais Trocados</h2>
              </div>
            </div>

            <div class="p-6 pb-0">
              <vs-table noDataText="Nenhum dado encontrado" class="tablePrincipal" ref="table"
                v-model="selectedRankingMaisTrocados" :data="rankingMaisTrocados"
                style="overflow-y: auto; height: 283px !important">
                <template slot="thead">
                  <vs-th :style="{ width: '60%' }">Produto</vs-th>
                  <vs-th :style="{ width: '40%' }">Trocas</vs-th>
                </template>

                <template slot-scope="{ data }">
                  <tbody>
                    <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                      <vs-td>
                        <p class="product-category">{{ tr.nomeProduto }}</p>
                      </vs-td>
                      <vs-td>
                        <p class="product-category">
                          {{ tr.quantidadeTrocada }}
                        </p>
                      </vs-td>
                    </vs-tr>
                  </tbody>
                </template>
              </vs-table>
            </div>
          </div>
        </vx-card>
      </div>

      <div id="rankingMaisEncomendados"
        class="divRankingMaisEncomendados vs-con-loading__container vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/2 xl:w-1/2 mb-base">
        <vx-card class="overflow-hidden">
          <div slot="no-body">
            <div class="p-6 pb-3 mb-3 flex justify-between flex-row-reverse items-center">
              <feather-icon icon="ShoppingBagIcon" class="p-3 inline-flex rounded-full text-success"
                :style="{ background: `rgba(var(--vs-success),.15)` }"></feather-icon>
              <div>
                <h2 class="mb-1 font-bold">
                  Produtos Mais Encomendados
                </h2>
              </div>
            </div>

            <div class="p-6 pb-0">
              <vs-table noDataText="Nenhum dado encontrado" class="tablePrincipal" ref="table"
                v-model="selectedRankingMaisEncomendados" :data="rankingMaisEncomendados"
                style="overflow-y: auto; height: 283px !important">
                <template slot="thead">
                  <vs-th style="width: 70%">Produto</vs-th>
                  <vs-th style="width: 30%">Encomendas</vs-th>
                </template>

                <template slot-scope="{ data }">
                  <tbody>
                    <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                      <vs-td>
                        <p class="product-category">{{ tr.nomeProduto }}</p>
                      </vs-td>
                      <vs-td>
                        <p class="product-category">
                          {{ tr.quantidadeEncomendada }}
                        </p>
                      </vs-td>
                    </vs-tr>
                  </tbody>
                </template>
              </vs-table>
            </div>
          </div>
        </vx-card>
      </div>
    </div>
    <div class="vx-row" style="margin-top: 2%">
      <div id="encomendas"
        class="divEncomendas vs-con-loading__container vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/2 xl:w-1/2 mb-base">
        <statistics-card-line icon="GiftIcon" statistic="Encomendas" :chartData="analyticsData.encomendas"
          color="primary" type="bar" :height="250" :iconRight="true" v-if="encomendasShow"></statistics-card-line>
      </div>

      <div id="valorCustoCompra"
        class="divCustoMercadorias vs-con-loading__container vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/2 xl:w-1/2 mb-base">
        <statistics-card-line icon="DollarSignIcon" statistic="Valor do Custo de Compra"
          :chartData="analyticsData.valorCustoCompra" color="warning" type="bar" :height="250" :iconRight="true"
          v-if="valorCustoCompraShow"></statistics-card-line>
      </div>
    </div>
  </div>
</template>

<script>
import VueApexCharts from "vue-apexcharts";
import StatisticsCardLine from "@/components/statistics-cards/StatisticsCardLine.vue";
import analyticsData from "./../ui-elements/card/analyticsData.js";
import ChangeTimeDurationDropdown from "@/components/ChangeTimeDurationDropdown.vue";
import service from "./../services";
import Filtro from "./filtros/FiltroDashBoard";
import moment from "moment";
import jwt from "jsonwebtoken";
import VueJsonPretty from "vue-json-pretty";
export default {
  data() {
    return {
      isReadonly: true,
      modalPayload: false,
      modalSincronizar: false,
      itemSincronizar: null,
      jsonPayload: {},
      decoded: null,
      filtro: null,
      objSend: {},
      acoes: [],
      aberturas: [],
      selectedAberturas: [],
      rankingAberturas: [],
      selectedRankingAberturas: [],
      rankingMaisAbertas: [],
      selectedRankingMaisAbertas: [],
      rankingMaisResgatados: [],
      selectedRankingMaisResgatados: [],
      rankingMaisTrocados: [],
      selectedRankingMaisTrocados: [],
      rankingMaisEncomendados: [],
      selectedRankingMaisEncomendados: [],
      tipoVendas: "Valor à Vista",
      analyticsData: analyticsData,
      chatMsgInput: "",
      contentImg1: "content-img-1.jpg",
      profileUser1: "avatar-s-18.png",
      profileUser2: "avatar-s-1.png",
      profileUser3: "avatar-s-12.png",
      overlayImg2: "card-image-5.jpg",
      freteGratisShow: false,
      encomendasShow: false,
      valorAcumuladoShow: false,
      churnShow: false,
      qtdUsuariosShow: false,
      valorCustoCompraShow: false,
      userRules: {},
      settings: {
        // perfectscrollbar settings
        maxScrollbarLength: 60,
        wheelSpeed: 0.6,
      },
      chatMsg: [
        {
          senderImg: "avatar-s-2.png",
          msg: "Cake sesame snaps cupcake gingerbread",
          isSent: true,
        },
        {
          senderImg: "avatar-s-5.png",
          msg: "Apple pie pie jujubes chupa chups muffin",
          isSent: false,
        },
        { senderImg: "avatar-s-2.png", msg: "Chocolate cake", isSent: true },
        {
          senderImg: "avatar-s-5.png",
          msg: "Donut sweet pie oat cake dragée fruitcake",
          isSent: false,
        },
        {
          senderImg: "avatar-s-2.png",
          msg: "Liquorice chocolate bar jelly beans icing",
          isSent: true,
        },
        {
          senderImg: "avatar-s-5.png",
          msg: "Powder toffee tootsie roll macaroon cupcake.",
          isSent: false,
        },
        {
          senderImg: "avatar-s-2.png",
          msg: "Apple pie oat cake brownie cotton candy cupcake chocolate bar dessert.",
          isSent: true,
        },
        {
          senderImg: "avatar-s-5.png",
          msg: "Biscuit cake jujubes carrot cake topping sweet cake.",
          isSent: false,
        },
      ],
    };
  },
  methods: {
    canAccess(resource, action) {
      if (this.userRules.All && this.userRules.All.includes("*")) return true;
      if (this.userRules[resource] && this.userRules[resource].includes(action)) return true;
      return false;
    },
    formatCurrency(value) {
      return new Intl.NumberFormat("pt-BR", {
        style: "currency",
        currency: "BRL",
      }).format(value);
    },
    formatarHorasDecimais(valor) {
      const horas = Math.floor(valor);
      const minutos = Math.round((valor - horas) * 60);
      return `${horas}h ${minutos}min`;
    },
    marcarComoSincronizado() {
      this.$vs.loading();
      var objSend = { ...this.itemSincronizar };
      service
        .post("Acoes", "MarcarComoSincronizado", objSend)
        .then(() => {
          this.modalSincronizar = false;
          this.itemSincronizar = null;
          this.buscaDadosAcoes();
          this.$vs.loading.close();
        })
        .catch((e) => {
          this.$vs.notify({
            position: "top-center",
            title: "Atenção",
            text: e,
            color: "danger",
          });
          this.$vs.loading.close();
        });
    },
    abrirModal(item) {
      this.modalPayload = true;
      this.jsonPayload = JSON.parse(item.payload);
    },
    abrirModalSincronizado(item) {
      this.modalSincronizar = true;
      this.itemSincronizar = item;
    },
    getStatusColor(data) {
      if (data.dataSincronizado != null) return "success";
      return "danger";
    },
    getStatusString(data) {
      if (data.dataSincronizado != null)
        return `Sincronizado por ${data.sincronizadoPor
          } em ${this.formataDataUTC(data.dataSincronizado)}`;
      return "Não Sincronizado";
    },
    filtraGeral() {
      this.preparaFiltro();
      this.buscaDadosValoresCredito();
      this.buscaDadosCaixas();
      this.buscaDadosQtdUsuarios();
      this.buscaDadosValorAcumulado();
      this.buscaDadosTicketMedioIncluido();
      this.buscaDadosTicketMedioCML();
      this.buscaDadosTicketMedioVME();
      this.buscaDadosChurn();
      this.buscaDadosLTV();
      this.buscaDadosTaxaRecompra();
      this.buscaDadosTempoEntreCompras();
      this.buscaDadosAberturas();
      this.buscaRankingAberturas();
      this.buscaRankingMaisAbertas();
      this.buscaRankingMaisResgatados();
      this.buscaRankingMaisTrocados();
      this.buscaRankingMaisEncomendados();
      this.buscaDadosEncomendas();

      if (!this.isReadonly) {
        this.buscaDadoscustoMercadorias();
        this.buscaFreteGratis();
      }
      //this.buscaDadosBeneficios();
      //this.buscaDadosBeneficiosValores();
      //this.buscaDadosAcoes();
    },
    // getDecoded() {
    //   const token = localStorage.getItem("user-token");
    //   if (token) {
    //     this.decoded = jwt.decode(token);
    //     this.idEmpresa = this.decoded.id_empresa;
    //     this.isReadonly = this.decoded.readOnly || false;
    //     this.filtraGeral();
    //   }
    // },
    getDecoded() {
      const token = localStorage.getItem("user-token");
      if (token) {
        this.decoded = jwt.decode(token);
        this.idEmpresa = this.decoded.idEmpresa || this.decoded.id_empresa;
        this.isReadonly = this.decoded.readOnly || false;
        this.userRules = this.decoded.rules || {};

        this.filtraGeral();
        console.log('decoded no home2', this.decoded)
      }
    },

    makeFiltro(filtro) {
      this.filtro = filtro;
      this.filtraGeral();
    },
    dataInicio() {
      var date = new Date();
      var primeiroDia = new Date(date.getFullYear(), date.getMonth(), 1);
      return primeiroDia;
    },
    formataDataUTC(data) {
      return moment(data).utc().format("DD/MM/YYYY HH:mm");
    },
    preparaFiltro() {
      this.objSend = {};
      if (this.filtro) {
        this.objSend = { ...this.filtro };
        this.objSend.dataInicial = moment(this.filtro.dataInicial).format(
          "YYYY-MM-DD"
        );
        this.objSend.dataFinal = moment(this.filtro.dataFinal).format(
          "YYYY-MM-DD"
        );
      } else {
        var date = new Date();
        var primeiroDia = new Date(date.getFullYear(), date.getMonth(), 1);
        var ultimoDia = new Date(date.getFullYear(), date.getMonth() + 1, 0);
        this.objSend.dataInicial = moment(primeiroDia).format("YYYY-MM-DD");
        this.objSend.dataFinal = moment(ultimoDia).format("YYYY-MM-DD");
      }
    },
    calculaTaxadeConversao() {
      var total =
        (analyticsData.vistoriasRealizadas.qtd * 100) /
        analyticsData.cotacoesGeradas.qtd;
      return [total.toFixed()];
    },
    buscaDadosAcoes() {
      this.$vs.loading({
        container: "#divAcoes",
        scale: 0.6,
      });
      var objSend = { ...this.objSend };
      service.post("Relatorios", "dashBoardAcoes", objSend).then((res) => {
        this.acoes = res.data;
        this.$vs.loading.close("#divAcoes > .con-vs-loading");
      });
    },
    buscaDadosValoresCredito() {
      this.$vs.loading({
        container: ".divCreditos",
        scale: 0.6,
      });
      var objSend = { ...this.objSend };
      objSend.tipo = "Creditos";
      objSend.idEmpresa = this.idEmpresa;
      service.post("Relatorios", "numerosGerais", objSend).then((res) => {
        let qtdPago = res.data.qtds.find((x) => x.tipo == "Pago");
        let qtdAberto = res.data.qtds.find(
          (x) => x.tipo == "Aguardando Pagamento"
        );
        analyticsData.valorCreditado.qtd = qtdPago ? qtdPago.qtd : 0;
        analyticsData.valorEmAberto.qtd = qtdAberto ? qtdAberto.qtd : 0;
        analyticsData.valorCreditado.series[0].data = res.data.dados;
        this.$vs.loading.close(".divCreditos > .con-vs-loading");
      });
    },
    buscaDadosCaixas() {
      this.$vs.loading({
        container: ".divCaixas",
        scale: 0.6,
      });
      var objSend = { ...this.objSend };
      objSend.tipo = "Caixas";
      objSend.idEmpresa = this.idEmpresa;
      service.post("Relatorios", "numerosGerais", objSend).then((res) => {
        let qtdCaixasAbertas = res.data.qtds[0].qtdAbertura;
        let qtdValorEmAbertura = res.data.qtds[0].totalAbertura;
        let cmeFinanceiro = res.data.cmeFinanceiro;
        let cmvFinanceiro = res.data.cmv;
        let lucroBruto = res.data.lucroBruto;
        let totalReceita = res.data.totalReceita;
        let quantidadeTotalVendida = res.data.quantidadeTotalVendida;
        let lucroSobreTroca = res.data.lucroSobreTroca;
        let totalDeFretePago = res.data.totalDeFretePago;
        let saldoTotal = res.data.saldoTotal;
        let cmlTotal = res.data.cmlTotal;
        let totalVendas = res.data.totalVendas;

        analyticsData.totalVendas = totalVendas;
        analyticsData.totalDeFretePago = totalDeFretePago;
        analyticsData.lucroSobreTroca = lucroSobreTroca;
        analyticsData.quantidadeTotalVendida = quantidadeTotalVendida;
        analyticsData.totalReceita = totalReceita;
        analyticsData.lucroBruto = lucroBruto;
        analyticsData.cmvFinanceiro = cmvFinanceiro;
        analyticsData.cmeFinanceiro = cmeFinanceiro;
        analyticsData.qtdCaixasAbertas.qtd = qtdCaixasAbertas;
        analyticsData.valorEmAbertura.qtd = qtdValorEmAbertura;
        analyticsData.saldoTotal = saldoTotal;
        analyticsData.cmlTotal = cmlTotal;

        analyticsData.qtdCaixasAbertas.series[0].data = res.data.dados;
        analyticsData.valorEmAbertura.series[0].data = res.data.dados;
        this.$vs.loading.close(".divCaixas > .con-vs-loading");
      });
    },
    buscaDadosBeneficios() {
      this.$vs.loading({
        container: "#divBeneficios",
        scale: 0.6,
      });
      var objSend = { ...this.objSend };
      objSend.tipo = "Beneficios";
      objSend.idEmpresa = this.idEmpresa;
      service.post("Relatorios", "numerosGerais", objSend).then((res) => {
        analyticsData.cotacoesRecusadas.qtd = res.data.qtd;
        analyticsData.cotacoesRecusadas.series[0].data = res.data.dados;
        this.$vs.loading.close("#divBeneficios > .con-vs-loading");
      });
    },
    buscaDadosBeneficiosValores() {
      this.$vs.loading({
        container: "#divBeneficiosValor",
        scale: 0.6,
      });
      var objSend = { ...this.objSend };
      objSend.tipo = "BeneficiosValores";
      objSend.idEmpresa = this.idEmpresa;
      service.post("Relatorios", "numerosGerais", objSend).then((res) => {
        analyticsData.cotacoesEmAberto.qtd = res.data.qtd;
        analyticsData.cotacoesEmAberto.series[0].data = res.data.dados;
        this.$vs.loading.close("#divBeneficiosValor > .con-vs-loading");
      });
    },
    buscaDadoscustoMercadorias() {
      this.$vs.loading({
        container: ".divCustoMercadorias",
        scale: 0.6,
      });
      var objSend = { ...this.objSend };
      objSend.tipo = "Creditos";
      objSend.idEmpresa = this.idEmpresa;
      service.post("Relatorios", "custoMercadorias", objSend).then((res) => {
        let categories = res.data.categories;
        let data = res.data.data;
        analyticsData.valorCustoCompra.series = [
          {
            name: "Custo",
            data: data,
          },
        ];
        analyticsData.valorCustoCompra.chartOptions = {
          xaxis: { categories: categories },
        };
        this.valorCustoCompraShow = true;
        this.$vs.loading.close(".divCustoMercadorias > .con-vs-loading");
      });
    },
    buscaDadosQtdUsuarios() {
      this.$vs.loading({
        container: ".divQtdUsuarios",
        scale: 0.6,
      });
      var objSend = { ...this.objSend };
      objSend.tipo = "Creditos";
      objSend.idEmpresa = this.idEmpresa;
      service.post("Relatorios", "qtdUsuarios", objSend).then((res) => {
        let categories = res.data.categories;
        let data = res.data.data;
        analyticsData.qtdUsuarios.series = [
          {
            name: "Quantidade",
            data: data,
          },
        ];
        analyticsData.qtdUsuarios.chartOptions = {
          xaxis: { categories: categories },
        };
        this.qtdUsuariosShow = true;
        this.$vs.loading.close(".divQtdUsuarios > .con-vs-loading");
        this.dadosDoBackend = true;
      });
    },
    buscaDadosValorAcumulado() {
      this.$vs.loading({
        container: ".divValorAcumulado",
        scale: 0.6,
      });
      var objSend = { ...this.objSend };
      objSend.tipo = "Creditos";
      objSend.idEmpresa = this.idEmpresa;
      service.post("Relatorios", "valorAcumulado", objSend).then((res) => {
        let categories = res.data.categories;
        let data = res.data.data;
        analyticsData.valorAcumulado.series = [
          {
            name: "Valor",
            data: data,
          },
        ];
        analyticsData.valorAcumulado.chartOptions = {
          xaxis: { categories: categories },
        };
        this.valorAcumuladoShow = true;
        this.$vs.loading.close(".divValorAcumulado > .con-vs-loading");
        this.dadosDoBackend = true;
      });
    },

    buscaDadosTicketMedioIncluido() {
      this.$vs.loading({
        container: ".divTicketMedioIncluido",
        scale: 0.6,
      });
      var objSend = { ...this.objSend };
      objSend.tipo = "TicketMedioIncluido";
      service.post("Relatorios", "ticketMedioIncluido", objSend).then((res) => {
        analyticsData.ticketMedioIncluido.qtd = res.data.qtd;
        analyticsData.ticketMedioIncluido.chartOptions.xaxis.categories = res.data.labels;
        analyticsData.ticketMedioIncluido.series[0].data = res.data.dados;
        this.$vs.loading.close(".divTicketMedioIncluido > .con-vs-loading");
      });

    },

    buscaDadosTicketMedioCML() {
      this.$vs.loading({
        container: ".divTicketMedioCML",
        scale: 0.6,
      });

      const objSend = { ...this.objSend, tipo: "TicketMedioCML" };

      service.post("Relatorios", "ticketMedioCML", objSend).then((res) => {
        analyticsData.ticketMedioCML.qtd = parseFloat(res.data.qtd.toFixed(2));
        analyticsData.ticketMedioCML.chartOptions.xaxis.categories = res.data.labels;
        analyticsData.ticketMedioCML.series[0].data = res.data.dados;

        this.$vs.loading.close(".divTicketMedioCML > .con-vs-loading");
      });
    },
    buscaDadosTicketMedioVME() {
      this.$vs.loading({
        container: ".divTicketMedioVME",
        scale: 0.6,
      });

      const objSend = { ...this.objSend, tipo: "TicketMedioVME" };

      service.post("Relatorios", "ticketMedioVME", objSend).then((res) => {
        analyticsData.ticketMedioVME.qtd = parseFloat(res.data.qtd.toFixed(2));
        analyticsData.ticketMedioVME.chartOptions.xaxis.categories = res.data.labels;
        analyticsData.ticketMedioVME.series[0].data = res.data.dados;

        this.$vs.loading.close(".divTicketMedioVME > .con-vs-loading");
      });
    },
    buscaDadosChurn() {
      this.$vs.loading({
        container: ".divChurn",
        scale: 0.6,
      });

      const objSend = { ...this.objSend, tipo: "Churn" };

      service.post("Relatorios", "churn", objSend).then((res) => {
        const churn = parseFloat(res.data.churnPercent.toFixed(2));
        const retention = parseFloat(res.data.retentionPercent.toFixed(2));

        analyticsData.churn.qtd = churn;
        analyticsData.churn.series[0].data = [churn];
        analyticsData.churn.chartOptions.xaxis.categories = [
          `${objSend.dataInicial} até ${objSend.dataFinal}`
        ];

        analyticsData.retention.qtd = retention;
        analyticsData.retention.series[0].data = [retention];
        analyticsData.retention.chartOptions.xaxis.categories = [
          `${objSend.dataInicial} até ${objSend.dataFinal}`
        ];


        this.$vs.loading.close(".divChurn > .con-vs-loading");
      });
    },
    buscaDadosLTV() {
      this.$vs.loading({
        container: ".divLTV",
        scale: 0.6,
      });

      const objSend = { ...this.objSend, tipo: "LTV" };

      service.post("Relatorios", "ltv", objSend).then((res) => {
        const ltv = parseFloat(res.data.ltv.toFixed(2));

        analyticsData.ltv.qtd = ltv;
        analyticsData.ltv.series[0].data = [ltv];
        analyticsData.ltv.chartOptions.xaxis.categories = [
          `${objSend.dataInicial} até ${objSend.dataFinal}`
        ];

        this.$vs.loading.close(".divLTV > .con-vs-loading");
      });
    },
    buscaDadosTaxaRecompra() {
      this.$vs.loading({
        container: ".divRecompra",
        scale: 0.6,
      });

      const objSend = { ...this.objSend, tipo: "TaxaRecompra" };

      service.post("Relatorios", "taxaRecompra", objSend).then((res) => {
        const taxa = parseFloat(res.data.taxaRecompraPercent.toFixed(2));

        analyticsData.taxaRecompra.qtd = taxa;
        analyticsData.taxaRecompra.series[0].data = [taxa];
        analyticsData.taxaRecompra.chartOptions.xaxis.categories = [
          `${objSend.dataInicial} até ${objSend.dataFinal}`
        ];

        this.$vs.loading.close(".divRecompra > .con-vs-loading");
      });
    },

    buscaDadosTempoEntreCompras() {
      this.$vs.loading({
        container: ".divTempoEntreCompras",
        scale: 0.6,
      });

      const objSend = { ...this.objSend, tipo: "TempoEntreCompras" };

      service.post("Relatorios", "tempoMedioEntreCompras", objSend).then((res) => {
        const tempoMedioDias = res.data.tempoMedioDias;
        const tempoMedioHoras = (tempoMedioDias * 24).toFixed(2);

        analyticsData.tempoEntreCompras.qtd = parseFloat(tempoMedioHoras);
        analyticsData.tempoEntreCompras.series[0].data = [parseFloat(tempoMedioHoras)];
        analyticsData.tempoEntreCompras.chartOptions.xaxis.categories = [
          `${objSend.dataInicial} até ${objSend.dataFinal}`
        ];


        this.$vs.loading.close(".divTempoEntreCompras > .con-vs-loading");
      });
    },

    buscaDadosAberturas() {
      this.$vs.loading({
        container: ".divAberturas",
        scale: 0.6,
      });
      var objSend = { ...this.objSend };
      objSend.tipo = "Creditos";
      objSend.idEmpresa = this.idEmpresa;
      service.post("Relatorios", "ultimasAberturas", objSend).then((res) => {
        this.aberturas = res.data;

        this.$vs.loading.close(".divAberturas > .con-vs-loading");
        this.dadosDoBackend = true;
      });
    },
    buscaRankingAberturas() {
      this.$vs.loading({
        container: ".divRankingAberturas",
        scale: 0.6,
      });
      var objSend = { ...this.objSend };
      objSend.tipo = "Creditos";
      objSend.idEmpresa = this.idEmpresa;
      service.post("Relatorios", "rankingAberturas", objSend).then((res) => {
        this.rankingAberturas = res.data;

        this.$vs.loading.close(".divRankingAberturas > .con-vs-loading");
        this.dadosDoBackend = true;
      });
    },
    buscaRankingMaisAbertas() {
      this.$vs.loading({
        container: ".divRankingMaisAbertas",
        scale: 0.6,
      });
      const objSend = { ...this.objSend };
      objSend.idEmpresa = this.idEmpresa;
      service.post("Relatorios", "rankingMaisAbertas", objSend).then((res) => {
        this.rankingMaisAbertas = res.data;
        this.$vs.loading.close(".divRankingMaisAbertas > .con-vs-loading");
      });
    },
    buscaRankingMaisResgatados() {
      this.$vs.loading({
        container: ".divRankingMaisResgatados",
        scale: 0.6,
      });

      const objSend = { ...this.objSend };

      service
        .post("Relatorios", "rankingMaisResgatados", objSend)
        .then((res) => {
          this.rankingMaisResgatados = res.data;
          this.$vs.loading.close(".divRankingMaisResgatados > .con-vs-loading");
        });
    },
    buscaRankingMaisTrocados() {
      this.$vs.loading({
        container: ".divRankingMaisTrocados",
        scale: 0.6,
      });

      const objSend = { ...this.objSend };

      service.post("Relatorios", "rankingMaisTrocados", objSend).then((res) => {
        this.rankingMaisTrocados = res.data;
        this.$vs.loading.close(".divRankingMaisTrocados > .con-vs-loading");
      });
    },
    buscaRankingMaisEncomendados() {
      this.$vs.loading({
        container: ".divRankingMaisEncomendados",
        scale: 0.6,
      });

      const objSend = { ...this.objSend };

      service
        .post("Relatorios", "rankingMaisEncomendados", objSend)
        .then((res) => {
          this.rankingMaisEncomendados = res.data;
          this.$vs.loading.close(
            ".divRankingMaisEncomendados > .con-vs-loading"
          );
        });
    },

    buscaDadosEncomendas() {
      this.$vs.loading({
        container: ".divEncomendas",
        scale: 0.6,
      });
      var objSend = { ...this.objSend };
      objSend.tipo = "Creditos";
      objSend.idEmpresa = this.idEmpresa;
      service.post("Relatorios", "encomendas", objSend).then((res) => {
        let categories = res.data.categories;
        let data = res.data.data;
        analyticsData.encomendas.series = [
          {
            name: "Valor",
            data: data,
            colors: this.generateRandomColors(data.length),
          },
        ];
        analyticsData.encomendas.chartOptions = {
          plotOptions: {
            bar: {
              horizontal: false,
              endingShape: "rounded",
            },
          },
          xaxis: { categories: categories },
        };
        this.encomendasShow = true;
        this.$vs.loading.close(".divEncomendas > .con-vs-loading");
        this.dadosDoBackend = true;
      });
    },
    buscaFreteGratis() {
      this.$vs.loading({
        container: ".divFreteGratis",
        scale: 0.6,
      });
      var objSend = { ...this.objSend };
      objSend.tipo = "Creditos";
      objSend.idEmpresa = this.idEmpresa;
      service.post("Relatorios", "freteGratis", objSend).then((res) => {
        let categories = res.data.categories;
        let data = res.data.data;
        analyticsData.freteGratis.series = [
          {
            name: "Valor",
            data: data,
          },
        ];
        analyticsData.freteGratis.chartOptions = {
          plotOptions: {
            bar: {
              horizontal: false,
              endingShape: "rounded",
            },
          },
          xaxis: { categories: categories },
        };
        this.freteGratisShow = true;
        this.$vs.loading.close(".divFreteGratis > .con-vs-loading");
        this.dadosDoBackend = true;
      });
    },
    generateRandomColors(count) {
      const colors = [];
      for (let i = 0; i < count; i++) {
        const randomColor =
          "#" + Math.floor(Math.random() * 16777215).toString(16);
        colors.push(randomColor);
      }
      return colors;
    },
  },
  components: {
    VueApexCharts,
    StatisticsCardLine,
    ChangeTimeDurationDropdown,
    Filtro,
    VueJsonPretty,
  },
  mounted() {
    this.getDecoded();
  },
};
</script>

<style lang="scss">
.chat-card-log {
  height: 400px;

  .chat-sent-msg {
    background-color: #f2f4f7 !important;
  }
}
</style>
<style scoped lang="scss">
@import url("https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css");

.table-bordered {
  display: table;
  border-collapse: separate;
  box-sizing: border-box;
  border-spacing: 2px;
  border-color: grey;
  width: 100%;

  tr td {
    padding: 5px;
    font-size: 12px;
  }

  tr:nth-child(2n) {
    background: #efefef;
  }
}

.vs-tabs-primary .activeChild button,
.vs-tabs-primary button:not(:disabled):hover {
  color: #fff !important;
}

.forceWhite:hover {
  color: #fff !important;
}

.cards {
  height: 140px;
  margin-top: 10px;
}
</style>
